import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoDocuments = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--background-complete--inject-5",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 276.82,
					y: 139.09,
					width: 59.46,
					height: 45.99,
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "281.43 180.89 297.88 155.69 311.33 171.8 319.51 163.24 331.67 180.89 281.43 180.89",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M313.83,157.22a3.64,3.64,0,1,1-3.64-3.64A3.64,3.64,0,0,1,313.83,157.22Z",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M238.68,203.68,204.51,217.1a160,160,0,0,0-15.71-47.61l31.25-13.44C232,170.72,236.4,186.78,238.68,203.68Z",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "162.71 96.69 84.18 98.31 86.29 200.71 164.86 201.07 162.71 96.69",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "157.62 100.44 88.9 101.86 90.82 194.73 159.58 195.63 157.62 100.44",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "145.94 117.56 100.3 116.77 101.64 181.68 147.24 180.74 145.94 117.56",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "101.64 181.68 146.55 147.39 100.3 116.77 101.64 181.68",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "372.75 37.85 316.26 39.02 317.78 112.68 374.29 112.93 372.75 37.85",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "369.08 40.55 319.66 41.57 321.03 108.38 370.5 109.03 369.08 40.55",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "360.68 52.87 327.85 52.3 328.81 98.99 361.62 98.32 360.68 52.87",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "328.81 98.99 361.12 74.33 327.85 52.3 328.81 98.99",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "196.66 221.96 140.17 223.12 141.69 296.78 198.2 297.03 196.66 221.96",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "192.99 224.65 143.56 225.67 144.94 292.48 194.4 293.13 192.99 224.65",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "184.59 236.97 151.76 236.4 152.72 283.09 185.52 282.42 184.59 236.97",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "152.72 283.09 185.03 258.43 151.76 236.4 152.72 283.09",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "410.88 194.26 377.07 194.96 377.98 239.05 411.81 239.2 410.88 194.26",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "408.69 195.88 379.1 196.49 379.93 236.48 409.53 236.86 408.69 195.88",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "403.66 203.25 384.01 202.91 384.58 230.86 404.22 230.45 403.66 203.25",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "384.58 230.86 403.92 216.09 384.01 202.91 384.58 230.86",
					style: { fill: "#f5f5f5" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M220.47,62.42a7.62,7.62,0,0,1-1-.87c-.73-.65-1.65-1.47-2.74-2.46s-2.55-2.26-4.13-3.57c-.79-.66-1.63-1.33-2.52-2-.45-.33-.91-.65-1.39-1a4,4,0,0,0-1.48-.64,3.33,3.33,0,0,0-1.43.66c-.47.31-.92.65-1.35,1-.87.7-1.67,1.41-2.43,2.1-1.52,1.38-2.85,2.67-4,3.75L195.37,62a7.45,7.45,0,0,1-1,.92,5.81,5.81,0,0,1,.86-1.06c.57-.65,1.43-1.57,2.51-2.7s2.39-2.44,3.89-3.84c.76-.71,1.56-1.43,2.44-2.15.44-.35.89-.7,1.38-1a3.69,3.69,0,0,1,1.74-.74,4.31,4.31,0,0,1,1.73.72c.5.31,1,.65,1.42,1,.91.67,1.74,1.36,2.53,2,1.57,1.34,2.93,2.6,4.06,3.67s2,2,2.64,2.58A7.06,7.06,0,0,1,220.47,62.42Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "180.43 62.53 181.24 102.44 233.29 101.38 233.48 61.45 180.43 62.53",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "182.33 65.12 183.04 100.04 230.25 99.08 230.72 64.13 182.33 65.12",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "191.03 71.06 190.62 94.25 223.62 93.58 223.15 70.41 191.03 71.06",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.3,77c0,.15-5.1.26-11.4.26s-11.39-.11-11.39-.26,5.1-.26,11.39-.26S218.3,76.89,218.3,77Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.3,80.64c0,.14-5.1.26-11.4.26s-11.39-.12-11.39-.26,5.1-.26,11.39-.26S218.3,80.49,218.3,80.64Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.3,84.24c0,.14-5.1.26-11.4.26s-11.39-.12-11.39-.26,5.1-.26,11.39-.26S218.3,84.1,218.3,84.24Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M203.61,87.84a15.63,15.63,0,0,1-4.05.26,15.63,15.63,0,0,1-4.05-.26,31.67,31.67,0,0,1,8.1,0Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M199.92,75.39s0-.33-.22-.89a3.76,3.76,0,0,0-1.38-2,3.63,3.63,0,0,0-3.38-.46,3.54,3.54,0,0,0,0,6.63,3.63,3.63,0,0,0,3.38-.47,3.71,3.71,0,0,0,1.38-1.95c.17-.56.17-.9.22-.9a2,2,0,0,1,0,1,3.75,3.75,0,0,1-1.36,2.2,4,4,0,0,1-3.76.62,4,4,0,0,1,0-7.53,3.93,3.93,0,0,1,3.76.62,3.72,3.72,0,0,1,1.36,2.2A1.94,1.94,0,0,1,199.92,75.39Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M219.89,87.23s-.08.29-.36.76a3.32,3.32,0,0,1-1.73,1.52,1.87,1.87,0,0,1-1.66-.24,1.4,1.4,0,0,1-.36-1.9,1.2,1.2,0,0,1,.47-.39.73.73,0,0,1,.71.09,1.35,1.35,0,0,1,.42,1.12,3.28,3.28,0,0,1-.83,2.09,2.57,2.57,0,0,1-1,.69,1.58,1.58,0,0,1-1.21,0,2,2,0,0,1-1.17-1.78,3.42,3.42,0,0,1,.44-1.86.63.63,0,0,1,.49-.32.59.59,0,0,1,.5.29,1.84,1.84,0,0,1,.26.79,2.59,2.59,0,0,1-.8,2.16c-.42.38-.74.43-.74.4s.26-.15.59-.54a2.44,2.44,0,0,0,.58-2,1.59,1.59,0,0,0-.22-.61c-.13-.14-.17-.14-.31,0a3.2,3.2,0,0,0-.31,1.58,1.56,1.56,0,0,0,.88,1.35,1.48,1.48,0,0,0,1.59-.58,2.74,2.74,0,0,0,.71-1.75.94.94,0,0,0-.21-.72c-.11-.1-.34,0-.49.19a1,1,0,0,0,.23,1.27,1.5,1.5,0,0,0,1.3.24,3.39,3.39,0,0,0,1.67-1.29C219.69,87.45,219.86,87.21,219.89,87.23Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "247.1 145.32 211.03 161.35 210.17 133.86 246.2 116.83 247.1 145.32",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M426.26,119.31a11,11,0,0,1-1.6-1.33l-4.2-3.78c-1.79-1.58-3.91-3.47-6.33-5.48-1.22-1-2.5-2-3.87-3-.69-.5-1.4-1-2.14-1.46a6.32,6.32,0,0,0-2.26-1,5.09,5.09,0,0,0-2.2,1c-.72.48-1.41,1-2.08,1.54-1.32,1.07-2.56,2.17-3.73,3.22-2.33,2.12-4.37,4.1-6.07,5.76l-4,4a10.16,10.16,0,0,1-1.53,1.4,9.41,9.41,0,0,1,1.31-1.61c.89-1,2.2-2.42,3.85-4.14s3.67-3.75,6-5.91c1.16-1.08,2.4-2.19,3.74-3.29.67-.54,1.38-1.08,2.12-1.59a5.58,5.58,0,0,1,2.67-1.15,6.48,6.48,0,0,1,2.66,1.11c.76.48,1.48,1,2.18,1.5,1.39,1,2.67,2.09,3.88,3.12,2.41,2,4.5,4,6.24,5.63s3.11,3,4,4A9.82,9.82,0,0,1,426.26,119.31Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "364.8 119.48 366.05 180.75 445.94 179.13 446.23 117.83 364.8 119.48",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "367.73 123.46 368.81 177.06 441.27 175.59 441.99 121.95 367.73 123.46",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "381.08 132.58 380.45 168.18 431.1 167.15 430.37 131.58 381.08 132.58",
					style: { fill: "#ebebeb" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M422.93,141.75c0,.22-7.83.4-17.49.4S388,142,388,141.75s7.83-.4,17.49-.4S422.93,141.53,422.93,141.75Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M422.93,147.28c0,.22-7.83.4-17.49.4s-17.49-.18-17.49-.4,7.83-.4,17.49-.4S422.93,147.06,422.93,147.28Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M422.93,152.81c0,.22-7.83.4-17.49.4S388,153,388,152.81s7.83-.4,17.49-.4S422.93,152.59,422.93,152.81Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M400.39,158.34c0,.22-2.78.4-6.22.4s-6.22-.18-6.22-.4,2.78-.4,6.22-.4S400.39,158.12,400.39,158.34Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M394.72,139.23c-.08,0-.08-.51-.33-1.37a5.8,5.8,0,0,0-2.13-3,5.44,5.44,0,1,0,0,8.75,5.83,5.83,0,0,0,2.13-3c.25-.86.25-1.38.33-1.38a3,3,0,0,1,0,1.45,5.76,5.76,0,0,1-2.09,3.38,6,6,0,0,1-5.77.95,6.13,6.13,0,0,1,0-11.56,6,6,0,0,1,5.77,1,5.77,5.77,0,0,1,2.09,3.37A3,3,0,0,1,394.72,139.23Z",
					style: { fill: "#e0e0e0" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M425.38,157.4a3.46,3.46,0,0,1-.55,1.16,5.07,5.07,0,0,1-2.66,2.34,2.93,2.93,0,0,1-2.56-.37,2.16,2.16,0,0,1-.54-2.92,1.68,1.68,0,0,1,.72-.59,1.11,1.11,0,0,1,1.08.13,2.05,2.05,0,0,1,.65,1.72,5,5,0,0,1-1.27,3.21,3.92,3.92,0,0,1-1.48,1.06,2.38,2.38,0,0,1-1.85,0,3.12,3.12,0,0,1-1.8-2.73,5.4,5.4,0,0,1,.67-2.86,1,1,0,0,1,.76-.48.92.92,0,0,1,.77.44,2.9,2.9,0,0,1,.39,1.21,4,4,0,0,1-1.22,3.32c-.64.58-1.14.65-1.14.62s.4-.24.91-.84a3.78,3.78,0,0,0,.89-3,2.63,2.63,0,0,0-.33-.94c-.2-.22-.27-.21-.48.06a5.11,5.11,0,0,0-.49,2.43,2.41,2.41,0,0,0,1.36,2.07,2.27,2.27,0,0,0,2.44-.88,4.27,4.27,0,0,0,1.09-2.7,1.39,1.39,0,0,0-.33-1.09c-.16-.17-.52,0-.74.28a1.46,1.46,0,0,0,.34,2,2.34,2.34,0,0,0,2,.36,5.17,5.17,0,0,0,2.56-2C425.06,157.74,425.33,157.37,425.38,157.4Z",
					style: { fill: "#e0e0e0" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "freepik--Floor--inject-5",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M409,448.31c0,.15-77.09.26-172.16.26s-172.17-.11-172.17-.26,77.07-.26,172.17-.26S409,448.17,409,448.31Z",
				style: { fill: "#263238" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Plant--inject-5",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M330.16,394.58c-16.89-11.05-21.18-32.21-21-51.33,0-3.19-.4-6.55,1.06-9.38s5-4.83,7.94-3.56c2.42,1.06,3.54,3.79,4.94,6a18.88,18.88,0,0,0,7.75,7c2.08,1,4.64,1.59,6.65.43,2.75-1.58,3-5.39,2.88-8.56l-.54-17.73c-.1-3.17-.19-6.41.73-9.44s3.07-5.88,6.11-6.8,6.85.73,7.58,3.82a28.65,28.65,0,0,1,.18,3.94c.12,1.32.78,2.76,2.06,3.1s2.55-.59,3.49-1.54c3.24-3.28,5.39-7.46,7.39-11.61s3.94-8.4,6.87-12,7-6.43,11.61-6.8,9.57,2.32,10.84,6.75-1.26,9-4,12.73A71.67,71.67,0,0,1,378.08,314a5.8,5.8,0,0,0-2.44,2.71c-.64,2.13,1.44,4.18,3.57,4.83,2.42.72,5,.42,7.52.65s5.26,1.25,6.26,3.57c1.4,3.21-1.27,6.67-3.92,9a61.41,61.41,0,0,1-17.93,10.8c-2.34.91-4.81,1.71-6.67,3.4s-3,4.56-1.74,6.77,4.18,2.85,6.64,2.34,4.65-1.89,7-2.83c4.37-1.75,10.08-1.58,13,2.11a9.93,9.93,0,0,1,1.3,8.85,23,23,0,0,1-4.68,8,61.71,61.71,0,0,1-25.93,18.92c-10.16,3.75-19.62,4.93-29.89,1.5",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M392,282.66l-.31.31-.94.86c-.82.75-2,1.86-3.56,3.33a118.79,118.79,0,0,0-12,13.36c-2.32,3-4.73,6.38-7.25,10.06s-5.16,7.65-7.79,11.91a143.61,143.61,0,0,0-7.6,13.75c-1.18,2.45-2.23,5-3.29,7.63L346,351.82a288.69,288.69,0,0,0-10.7,30.79,139.63,139.63,0,0,0-4.7,26.16,102.44,102.44,0,0,0,.15,17.93c.23,2.1.43,3.74.61,4.84.08.54.14.95.19,1.26s.05.43.05.43a63.31,63.31,0,0,1-1-6.51,98.17,98.17,0,0,1-.31-18,137.31,137.31,0,0,1,4.62-26.25,280.58,280.58,0,0,1,10.68-30.86l3.22-7.95c1.06-2.61,2.11-5.19,3.3-7.65a141.93,141.93,0,0,1,7.65-13.78c2.65-4.27,5.32-8.22,7.85-11.9s5-7.06,7.3-10.05A113,113,0,0,1,387,287c1.55-1.46,2.78-2.55,3.63-3.28l1-.82Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M352.23,336a9.08,9.08,0,0,1-.32-1.35c-.19-.88-.41-2.15-.67-3.72-.53-3.15-1.1-7.52-1.73-12.34s-1.28-9.17-1.86-12.3c-.29-1.57-.54-2.83-.73-3.7a6.79,6.79,0,0,1-.23-1.37,8.49,8.49,0,0,1,.41,1.32c.24.86.54,2.12.88,3.68.67,3.12,1.38,7.48,2,12.31s1.16,9.1,1.58,12.35c.21,1.51.39,2.76.52,3.74A7,7,0,0,1,352.23,336Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M393.36,327.38a1.57,1.57,0,0,1-.43.08l-1.22.13c-1.06.11-2.59.27-4.48.53-3.77.48-9,1.34-14.65,2.53s-10.78,2.53-14.43,3.59c-1.83.52-3.3,1-4.32,1.3l-1.18.35a1.77,1.77,0,0,1-.42.1,1.49,1.49,0,0,1,.39-.19l1.15-.44c1-.37,2.46-.88,4.28-1.44,3.64-1.15,8.74-2.52,14.43-3.73s10.92-2,14.71-2.41c1.9-.21,3.44-.32,4.51-.37l1.23-.05A1.44,1.44,0,0,1,393.36,327.38Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M335.35,381.72a2.32,2.32,0,0,1-.29-.49l-.73-1.47c-.63-1.27-1.5-3.13-2.55-5.44-2.1-4.63-4.8-11.11-7.69-18.3s-5.54-13.68-7.56-18.33c-1-2.28-1.82-4.15-2.41-5.51-.27-.61-.48-1.11-.65-1.5a4,4,0,0,1-.2-.53,2.32,2.32,0,0,1,.29.49l.73,1.46c.63,1.28,1.5,3.14,2.55,5.45,2.1,4.63,4.8,11.11,7.69,18.3s5.54,13.67,7.56,18.33c1,2.28,1.81,4.15,2.41,5.51.27.61.48,1.11.65,1.5A3.47,3.47,0,0,1,335.35,381.72Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M389.82,363a4,4,0,0,1-.55.22l-1.58.56-5.84,2c-4.93,1.7-11.7,4.13-19.19,6.83s-14.28,5.08-19.24,6.7c-2.48.81-4.49,1.45-5.89,1.86l-1.61.47a2.48,2.48,0,0,1-.57.13,3,3,0,0,1,.54-.22l1.59-.56,5.83-2c4.93-1.7,11.71-4.13,19.19-6.83s14.28-5.08,19.24-6.7c2.48-.81,4.49-1.44,5.89-1.86l1.61-.47A2.38,2.38,0,0,1,389.82,363Z",
					style: { fill: "#263238" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--filing-cabinet--inject-5",
			children: [
				/* @__PURE__ */ _jsx("polygon", {
					points: "240.63 207.78 238.49 448.31 333.77 448.31 333.77 211.06 240.63 207.78",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "243.62 247.75 243.62 281.47 288.75 281.47 288.75 249.35 243.62 247.75",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "291.96 209.59 291.11 448.31 333.77 448.31 333.77 211.06 291.96 209.59",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "243.62 210.75 243.62 244.47 288.75 244.47 288.75 212.34 243.62 210.75",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "259.18 220.02 259.18 225 272.99 225 272.99 219.57 259.18 220.02",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 259.18,
					y: 229.19,
					width: 14.26,
					height: 2.04,
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .4 },
					children: [/* @__PURE__ */ _jsx("polygon", { points: "259.18 220.02 259.18 225 272.99 225 272.99 219.57 259.18 220.02" }), /* @__PURE__ */ _jsx("rect", {
						x: 259.18,
						y: 229.19,
						width: 14.26,
						height: 2.04
					})]
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "243.62 328.9 243.62 362.61 288.75 362.61 288.75 330.49 243.62 328.9",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "259.18 338.17 259.18 343.15 272.99 343.15 272.99 337.72 259.18 338.17",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 259.18,
					y: 347.34,
					width: 14.26,
					height: 2.04,
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .4 },
					children: [/* @__PURE__ */ _jsx("polygon", { points: "259.18 338.17 259.18 343.15 272.99 343.15 272.99 337.72 259.18 338.17" }), /* @__PURE__ */ _jsx("rect", {
						x: 259.18,
						y: 347.34,
						width: 14.26,
						height: 2.04
					})]
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "243.62 366.9 243.62 400.61 288.75 400.61 288.75 368.49 243.62 366.9",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "259.18 376.17 259.18 381.15 272.99 381.15 272.99 375.72 259.18 376.17",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 259.18,
					y: 385.34,
					width: 14.26,
					height: 2.04,
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .4 },
					children: [/* @__PURE__ */ _jsx("polygon", { points: "259.18 376.17 259.18 381.15 272.99 381.15 272.99 375.72 259.18 376.17" }), /* @__PURE__ */ _jsx("rect", {
						x: 259.18,
						y: 385.34,
						width: 14.26,
						height: 2.04
					})]
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "243.14 404.9 243.14 438.61 288.27 438.61 288.27 406.49 243.14 404.9",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "258.69 414.17 258.69 419.15 272.5 419.15 272.5 413.72 258.69 414.17",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 258.69,
					y: 423.34,
					width: 14.26,
					height: 2.04,
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .4 },
					children: [/* @__PURE__ */ _jsx("polygon", { points: "258.69 414.17 258.69 419.15 272.5 419.15 272.5 413.72 258.69 414.17" }), /* @__PURE__ */ _jsx("rect", {
						x: 258.69,
						y: 423.34,
						width: 14.26,
						height: 2.04
					})]
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 197.63,
					y: 287.5,
					width: 45.13,
					height: 33.72,
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "213.49 302.69 213.49 307.37 226.47 307.37 226.47 302.27 213.49 302.69",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 213.49,
					y: 311.31,
					width: 13.4,
					height: 1.91,
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .4 },
					children: [/* @__PURE__ */ _jsx("polygon", { points: "213.49 302.69 213.49 307.37 226.47 307.37 226.47 302.27 213.49 302.69" }), /* @__PURE__ */ _jsx("rect", {
						x: 213.49,
						y: 311.31,
						width: 13.4,
						height: 1.91
					})]
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "242.76 287.5 287.25 287.17 286.44 321.21 242.76 321.21 242.76 287.5",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "242.76 287.5 287.25 287.17 286.44 321.21 242.76 321.21 242.76 287.5",
					style: { opacity: .4 }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 241.19,
					y: 256.88,
					width: 44.48,
					height: 30.28,
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M230.4,261.71l2.24,25.73,53-.27L282.5,262a3,3,0,0,0-3.36-2.56l-21.39,1.86-3.64-2.7a1.75,1.75,0,0,0-1.14-.31l-21.12,1.86A1.53,1.53,0,0,0,230.4,261.71Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M230.4,261.71l2.24,25.73,53-.27L282.5,262a3,3,0,0,0-3.36-2.56l-21.39,1.86-3.64-2.7a1.75,1.75,0,0,0-1.14-.31l-21.12,1.86A1.53,1.53,0,0,0,230.4,261.71Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "215.19 280.74 214.07 274.04 263.1 270.8 267.41 287.43 216.16 287.17 215.19 280.74",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M208.93,277.48l.87,10h52.44L261,277.75a3,3,0,0,0-3.35-2.56l-21.39,1.86-3.65-2.7a1.7,1.7,0,0,0-1.13-.31l-21.12,1.87A1.51,1.51,0,0,0,208.93,277.48Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M208.93,277.48l.87,10h52.44L261,277.75a3,3,0,0,0-3.35-2.56l-21.39,1.86-3.65-2.7a1.7,1.7,0,0,0-1.13-.31l-21.12,1.87A1.51,1.51,0,0,0,208.93,277.48Z",
					style: {
						fill: "#fafafa",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M264.27,275.29h7a1.76,1.76,0,0,1,1.71,2.16l-2.26,9.71h-3.27Z",
					style: { fill: "#263238" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Documents--inject-5",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M356,141.33,324.89,148a2,2,0,0,1-2.38-1.62l-4.2-21a2.07,2.07,0,0,1,1.56-2.46l31.1-6.69a2,2,0,0,1,2.38,1.62l4.21,21A2.1,2.1,0,0,1,356,141.33Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "338.79 129.7 343.55 131.35 339.79 134.8 336.03 138.25 335.03 133.15 334.03 128.05 338.79 129.7",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M297.06,130.33l.31-.41c.22-.26.53-.65.93-1.18a28.91,28.91,0,0,0,3-4.94,27.3,27.3,0,0,0,1.5-3.89c.43-1.46.77-3.09,1.2-4.82.84-3.48,1.8-7.43,2.85-11.8s2.23-9.16,3.47-14.29a32.79,32.79,0,0,1,1.1-3.91,21.88,21.88,0,0,1,1.84-3.77,21.1,21.1,0,0,1,2.66-3.42,19.27,19.27,0,0,1,1.61-1.51l.05,0,0,0c.21.82,0,.22.08.4l-.13,0-.27-.07-.54-.13-1.08-.26-18.12-4.42-9.59-2.35-4.9-1.2-2.48-.6-.15,0-.08,0c-.05,0,.26,0,.11,0h0l-.29.11-.59.23c-.37.19-.77.34-1.13.55a15.72,15.72,0,0,0-6.83,7.07,19,19,0,0,0-1.48,4.68c-.37,1.6-.74,3.19-1.1,4.77-1.46,6.3-2.86,12.38-4.2,18.18l-1,4.29a32.14,32.14,0,0,1-5.37,11.28c-.4.53-.81,1-1.23,1.54l-.16.19-.08.1c-.21-.69,0-.19-.08-.34h.09l.47.12.93.23,3.64.9,6.86,1.7,20.66,5.14,5.62,1.43,1.45.38.5.15-.51-.1-1.47-.33-5.63-1.33-20.71-5-6.86-1.66-3.65-.89-.93-.22-.47-.12h-.09c-.06-.15.08.34-.14-.35l.08-.09.15-.19c.42-.49.82-1,1.21-1.53a31.82,31.82,0,0,0,3.95-7.09,51.16,51.16,0,0,0,2.3-8.33c1.33-5.8,2.73-11.88,4.17-18.19.37-1.58.73-3.17,1.1-4.77a19.37,19.37,0,0,1,1.51-4.78A16.23,16.23,0,0,1,278.12,68c.38-.22.79-.38,1.18-.56l.61-.24.3-.12,0,0h.18l.08,0,.16,0,2.47.61L288,69l9.59,2.35,18.11,4.45,1.08.27.54.13.27.07.13,0c.05.19-.06-.41.12.42l0,0-.05,0c-.55.47-1.08,1-1.58,1.48a20.41,20.41,0,0,0-4.42,7,33,33,0,0,0-1.09,3.85l-3.53,14.28-2.92,11.78c-.45,1.73-.81,3.35-1.26,4.82a27.49,27.49,0,0,1-1.54,3.91,26.87,26.87,0,0,1-3.08,4.91A17.68,17.68,0,0,1,297.06,130.33Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.69,87.44a4,4,0,0,1-1.12-.17c-.71-.14-1.74-.36-3-.64-2.53-.57-6-1.39-9.86-2.37s-7.3-2-9.79-2.7c-1.25-.37-2.25-.69-2.94-.92a4.22,4.22,0,0,1-1.05-.41,5.48,5.48,0,0,1,1.11.22l3,.76,9.81,2.54,9.83,2.52,3,.81A5.31,5.31,0,0,1,303.69,87.44Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303,91.63a5.27,5.27,0,0,1-1.12-.17c-.72-.14-1.74-.36-3-.65-2.53-.57-6-1.39-9.87-2.37s-7.29-2-9.78-2.69c-1.25-.38-2.25-.69-2.94-.92a4.78,4.78,0,0,1-1-.41,4.94,4.94,0,0,1,1.11.21l3,.76,9.81,2.55L299,90.46l3,.8A4.86,4.86,0,0,1,303,91.63Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M302,95.81a4.19,4.19,0,0,1-1.12-.16c-.72-.14-1.74-.37-3-.65-2.53-.57-6-1.39-9.87-2.37s-7.29-1.95-9.78-2.7c-1.25-.37-2.25-.68-2.94-.91a5.51,5.51,0,0,1-1.05-.41,4.3,4.3,0,0,1,1.11.21l3,.76,9.81,2.54L298,94.64l3,.81A5.6,5.6,0,0,1,302,95.81Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M301.13,100a4.56,4.56,0,0,1-1.12-.17c-.71-.14-1.74-.36-3-.64-2.53-.57-6-1.39-9.86-2.38s-7.3-1.94-9.79-2.69c-1.24-.37-2.24-.69-2.93-.92a4.44,4.44,0,0,1-1.06-.41,5.35,5.35,0,0,1,1.11.22l3,.75,9.82,2.55,9.82,2.52,3,.81A5,5,0,0,1,301.13,100Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M299.78,104.19a5.27,5.27,0,0,1-1.12-.17c-.72-.14-1.74-.36-3-.65-2.53-.57-6-1.39-9.87-2.37s-7.29-2-9.78-2.7c-1.25-.37-2.25-.68-2.94-.91A4.78,4.78,0,0,1,272,97a4.3,4.3,0,0,1,1.11.21l3,.76,9.81,2.55,9.83,2.51,3,.81A4.51,4.51,0,0,1,299.78,104.19Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M298.8,108.37a4,4,0,0,1-1.12-.17c-.71-.14-1.74-.36-3-.64-2.53-.57-6-1.39-9.86-2.37s-7.3-2-9.79-2.7c-1.24-.37-2.25-.69-2.94-.92a4.22,4.22,0,0,1-1.05-.41,5.48,5.48,0,0,1,1.11.22l3,.76,9.82,2.54,9.82,2.52,3,.81A5.31,5.31,0,0,1,298.8,108.37Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M297.56,112.71a4.19,4.19,0,0,1-1.12-.16c-.71-.14-1.74-.36-3-.65-2.53-.57-6-1.39-9.87-2.37s-7.29-2-9.78-2.7c-1.24-.37-2.25-.68-2.94-.91a4.78,4.78,0,0,1-1-.41,4.3,4.3,0,0,1,1.11.21l3,.76,9.81,2.55,9.83,2.51,3,.81A5.31,5.31,0,0,1,297.56,112.71Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M296.64,116.88a11.86,11.86,0,0,1-2.4-.39c-1.47-.31-3.49-.76-5.71-1.33s-4.2-1.19-5.64-1.62a10.72,10.72,0,0,1-2.29-.83,12.57,12.57,0,0,1,2.39.47c1.46.35,3.46.9,5.67,1.48s4.22,1.07,5.67,1.47A11.35,11.35,0,0,1,296.64,116.88Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.22,215.89l-34.17,13.42a160.19,160.19,0,0,0-15.7-47.6l21-9a15.27,15.27,0,0,1,20.4,8.9A167,167,0,0,1,232.22,215.89Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.22,215.89s0-.15-.08-.43-.12-.71-.2-1.23c-.18-1.08-.44-2.69-.82-4.75A175.12,175.12,0,0,0,227,192.21c-.54-1.8-1.11-3.69-1.76-5.63s-1.3-4-2.16-6a15,15,0,0,0-4-5.35,15.63,15.63,0,0,0-6.36-3.17,15,15,0,0,0-7.44.21c-.63.16-1.22.43-1.83.64l-1.82.79-3.71,1.59-15.45,6.65.13-.35c.27.54.56,1.13.86,1.72a167.38,167.38,0,0,1,9.67,24,154.42,154.42,0,0,1,5.15,22l-.28-.16,24.82-9.63,6.94-2.67,1.84-.69c.41-.16.64-.23.64-.23s-.19.1-.59.26l-1.78.73L223,219.64l-24.85,9.87-.24.1,0-.27a157.92,157.92,0,0,0-5.2-21.92A168.9,168.9,0,0,0,183,183.54l-.85-1.72-.13-.25.26-.1,15.45-6.64,3.71-1.6,1.82-.78c.64-.22,1.25-.49,1.89-.66a15.56,15.56,0,0,1,7.69-.19,16,16,0,0,1,6.54,3.28,15.28,15.28,0,0,1,4.12,5.53c.88,2.06,1.49,4.1,2.15,6.05s1.2,3.84,1.73,5.64a163.82,163.82,0,0,1,4,17.34c.34,2.08.58,3.68.72,4.79.06.53.11.94.15,1.25A2.16,2.16,0,0,1,232.22,215.89Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M204.49,172.24s5.1,10.46,4.65,10.83,12.66-4.89,12.82-5C222,178.1,215.18,169,204.49,172.24Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M202.58,186.34a25,25,0,0,1-4.63,2.24,26.32,26.32,0,0,1-4.82,1.76,24.31,24.31,0,0,1,4.62-2.24A26,26,0,0,1,202.58,186.34Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M219.54,184.84c.06.13-5.48,2.82-12.37,6s-12.53,5.65-12.59,5.52,5.48-2.81,12.37-6S219.48,184.71,219.54,184.84Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M221.84,191c.06.13-5.48,2.81-12.37,6s-12.53,5.66-12.59,5.53,5.48-2.81,12.37-6S221.78,190.86,221.84,191Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M224.19,197.11c.06.13-5.48,2.81-12.37,6s-12.53,5.65-12.59,5.52,5.48-2.81,12.37-6S224.13,197,224.19,197.11Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M217.58,208.46a13.67,13.67,0,0,1-2.32,1.22c-1.46.69-3.49,1.62-5.75,2.61-3.54,1.56-6.58,2.83-7.73,3.22l-.16.06,0-.15c.08-.37.14-.54.17-.54s0,.19,0,.57l-.12-.1c1.06-.58,4-2,7.59-3.53,2.26-1,4.32-1.87,5.82-2.48A12.36,12.36,0,0,1,217.58,208.46Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M375.86,215,337.93,198.6h0a31.72,31.72,0,0,0,9.1-12.29l11.07-26.58A15.9,15.9,0,0,1,370,150.38h0l35.18,15.24h0a20.56,20.56,0,0,0-8.55,9.62L384,204.37A27.84,27.84,0,0,1,375.86,215Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M375.86,215,337.93,198.6h0a31.72,31.72,0,0,0,9.1-12.29l11.07-26.58A15.9,15.9,0,0,1,370,150.38h0l35.18,15.24h0a20.56,20.56,0,0,0-8.55,9.62L384,204.37A27.84,27.84,0,0,1,375.86,215Z",
					style: {
						fill: "#fafafa",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M389.53,176.63c-.06.13-6.27-2.46-13.88-5.8s-13.73-6.14-13.67-6.27,6.27,2.46,13.88,5.8S389.59,176.5,389.53,176.63Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M388,181.86c-.06.13-6.48-2.56-14.35-6s-14.19-6.35-14.13-6.48,6.48,2.55,14.34,6S388,181.73,388,181.86Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M386,186.48c-.05.13-6.48-2.56-14.34-6s-14.19-6.34-14.14-6.47,6.48,2.55,14.35,6S386,186.34,386,186.48Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M383.93,191.1c-.06.13-6.48-2.56-14.35-6s-14.19-6.34-14.13-6.48,6.48,2.56,14.34,6S384,191,383.93,191.1Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M381.9,195.71c0,.14-6.48-2.55-14.34-6s-14.19-6.34-14.13-6.48,6.47,2.56,14.34,6S382,195.58,381.9,195.71Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M366.19,194.33a10,10,0,0,1-2.24-.78c-1.36-.54-3.22-1.32-5.26-2.22s-3.88-1.73-5.2-2.36a10.3,10.3,0,0,1-2.09-1.12,11.48,11.48,0,0,1,2.24.78c1.36.55,3.22,1.33,5.26,2.22s3.88,1.74,5.2,2.37A11,11,0,0,1,366.19,194.33Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M375.74,205c-.05,0,.11-.36.2-1a4.32,4.32,0,0,0-.54-2.66,4,4,0,1,0-2.6,5.93,4.24,4.24,0,0,0,2.32-1.41c.42-.51.58-.86.62-.84a2.16,2.16,0,0,1-.46,1,4.17,4.17,0,0,1-2.39,1.64,4.42,4.42,0,0,1-4.14-1.05,4.48,4.48,0,0,1,3.39-7.73,4.41,4.41,0,0,1,3.58,2.33,4.23,4.23,0,0,1,.41,2.87A2.21,2.21,0,0,1,375.74,205Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 363.4,
					y: 161.71,
					width: 12,
					height: 1.73,
					transform: "translate(96.31 -134.59) rotate(23.66)",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "353.91 262.05 312.96 261.09 328.2 240.69 368.15 240.69 353.91 262.05",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "319.04 258.03 351.43 259.02 346.93 252.4 340.56 255.13 335.52 246.42 319.04 258.03",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M346.07,246.36a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,346.07,246.36Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsxs("g", {
					style: { opacity: .7000000000000001 },
					children: [/* @__PURE__ */ _jsx("polygon", {
						points: "319.04 258.03 351.43 259.02 346.93 252.4 340.56 255.13 335.52 246.42 319.04 258.03",
						style: { fill: "#fafafa" }
					}), /* @__PURE__ */ _jsx("path", {
						d: "M346.07,246.36a2.1,2.1,0,1,1-2.1-2.1A2.1,2.1,0,0,1,346.07,246.36Z",
						style: { fill: "#fafafa" }
					})]
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "242.85 142.14 206.78 158.16 205.92 130.68 241.95 113.65 242.85 142.14",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "242.85 142.14 206.78 158.16 205.92 130.68 241.95 113.65 242.85 142.14",
					style: {
						fill: "#fafafa",
						opacity: .7000000000000001
					}
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "208.38 153.33 241.11 138.07 230.47 131.89 226.38 139.09 214.37 133.32 208.38 153.33",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M226.92,131.89a1.77,1.77,0,1,1-1.76-1.77A1.76,1.76,0,0,1,226.92,131.89Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M219.79,130.07a24.71,24.71,0,0,0-.49-3,12.5,12.5,0,0,0-4.56-6.77,12.32,12.32,0,0,0-11.63-1.72,11.52,11.52,0,0,0-3.1,1.67,11.67,11.67,0,0,0-2.59,2.61,12.23,12.23,0,0,0,0,14.47,11.67,11.67,0,0,0,2.59,2.61,11.52,11.52,0,0,0,3.1,1.67,12.39,12.39,0,0,0,6.44.55,12.25,12.25,0,0,0,5.19-2.28,12.48,12.48,0,0,0,4.56-6.76,24.34,24.34,0,0,0,.49-3,6.15,6.15,0,0,1,0,.8,6,6,0,0,1-.07,1,8.36,8.36,0,0,1-.24,1.31,12.55,12.55,0,0,1-9.86,9.41A12.65,12.65,0,0,1,203,142a12.75,12.75,0,0,1-5.94-4.43,12.66,12.66,0,0,1,0-15.08,12.17,12.17,0,0,1,2.71-2.7,12,12,0,0,1,3.23-1.72A12.59,12.59,0,0,1,215,120a12.41,12.41,0,0,1,4.53,7,8.16,8.16,0,0,1,.24,1.31,10.34,10.34,0,0,1,.06,1.76Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M199,139.31c.1.11-3.6,3.54-8.25,7.66s-8.51,7.38-8.6,7.28,3.6-3.54,8.25-7.67S198.92,139.2,199,139.31Z",
					style: { fill: "#263238" }
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "freepik--Character--inject-5",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M120.94,187.44c-3.44-1.86-8.59-.72-10.69,2.58a12.23,12.23,0,0,0-1.33,7.75c.27,2.66.94,5.27,1,7.94a10.2,10.2,0,0,1-.57,4.25,5.37,5.37,0,0,1-2.86,3.07c-2.05.82-4.61,0-6.44,1.27a3.85,3.85,0,0,0-.58,5.46,4.77,4.77,0,0,0,5.67,1c-1.93,1.79-1.57,5.24.38,7a7.24,7.24,0,0,0,7.42,1,14,14,0,0,0,5.92-5.05,31.54,31.54,0,0,0,5.6-18.49,42.26,42.26,0,0,0-3.94-17.85",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M233.25,245.8c-1.15-1.86-9.13,2.59-9.84,2.91s-1.19-.68-.54-.94c.93-.37,10.66-4.55,9.54-6.38-.62-1-2.35.26-2.35.26s-8.81,4.58-9.31,3.69,4.58-3.76,6.36-4.6,2.08-2,1.06-2.48c-.69-.33-6.21,2.13-7.95,3s-6.48,3.37-5.14.24,1.19-6,.6-6.79a1.06,1.06,0,0,0-1.83.84,12.46,12.46,0,0,1-.73,3.35,8,8,0,0,1-1.27,2.43c-.66.86-1.25,1.55-1.77,2.13-5.08,1.78-19.59,6.28-33.15,5-.49-.05-1.2-1-2-2.51l-18.39,5.92c.69,1.42,1.44,3,2.25,4.57,10.26,20.5,57.82-.77,57.82-.77l0-.05A100.41,100.41,0,0,0,227.17,253c4.76-1.71,4.61-2.14,4.32-2.66-.79-1.4-8.49,2.7-7.35.86S234.14,247.23,233.25,245.8Z",
					style: { fill: "#eb996e" }
				}),
				/* @__PURE__ */ _jsx("polygon", {
					points: "168.55 254.73 201.85 241.75 222.4 253.87 185.99 266.87 168.55 254.73",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M202.79,242.31l3.17-.85a80.37,80.37,0,0,1,16.44,12.41l-.93-.55Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M222.4,253.87A19.83,19.83,0,0,1,220,252c-1.47-1.19-3.52-2.81-5.83-4.53s-4.45-3.22-6-4.27a22.55,22.55,0,0,1-2.52-1.76,13.8,13.8,0,0,1,2.71,1.45,73.36,73.36,0,0,1,6.13,4.16c2.32,1.73,4.34,3.41,5.76,4.67A15.36,15.36,0,0,1,222.4,253.87Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M162.67,283.22l-1.45-30-.11-1.26L177,244.61l-5.06-12.39C166.36,211.31,146.44,211,146.44,211l-15.19-1.49L124.4,211s-12.69,2.19-13.17,20.28a70.76,70.76,0,0,0,6.86,31.9l4.65-2.43a14.75,14.75,0,0,1-2.57,8.25,26.75,26.75,0,0,0-4.09,9.39Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M128.06,227.42c.08,0,.2,1.48.55,3.86a59.59,59.59,0,0,0,5.59,17.83c1.07,2.15,1.82,3.44,1.75,3.48a3.9,3.9,0,0,1-.62-.85c-.38-.56-.88-1.4-1.46-2.46a49.59,49.59,0,0,1-5.62-17.95c-.14-1.2-.21-2.18-.22-2.86A3.62,3.62,0,0,1,128.06,227.42Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M159.11,245.88a8.08,8.08,0,0,0,2.79-2,5.21,5.21,0,0,0,1.22-3.38,4.48,4.48,0,0,0-2-3.78,4.23,4.23,0,0,0-3.23-.63l-.25.06-.05-.25c-.49-2.41-.89-4.49-1.16-6a15.21,15.21,0,0,1-.34-2.37,13.4,13.4,0,0,1,.65,2.3c.35,1.46.81,3.53,1.34,5.93l-.31-.19a4.67,4.67,0,0,1,3.63.67,4.93,4.93,0,0,1,2.16,4.22,5.46,5.46,0,0,1-1.42,3.63,6.11,6.11,0,0,1-2.15,1.51A2.17,2.17,0,0,1,159.11,245.88Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M161.66,258.3a33.5,33.5,0,0,1-.81-6.34c-.27-3.51-.71-6.32-.57-6.35a23.7,23.7,0,0,1,1.09,6.3A49.14,49.14,0,0,1,161.66,258.3Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M177.05,244.73a11.75,11.75,0,0,1-2.21,1.3c-1.4.73-3.36,1.7-5.57,2.69s-4.22,1.82-5.7,2.38a11.34,11.34,0,0,1-2.43.8,12.67,12.67,0,0,1,2.29-1.14l5.63-2.52,5.62-2.54A14,14,0,0,1,177.05,244.73Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.83,230.48a7.49,7.49,0,0,1,0-2.79,7.72,7.72,0,0,1,.48-2.76,7.54,7.54,0,0,1,0,2.8A7.69,7.69,0,0,1,117.83,230.48Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M119.32,236.68a5.25,5.25,0,0,1-2.22-.62,5.42,5.42,0,0,1-2-1.09,5.17,5.17,0,0,1,2.23.61C118.47,236.05,119.38,236.54,119.32,236.68Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M124.88,233.72a3.2,3.2,0,0,1-.21-2.06c.12-1.15.51-2,.64-2a6.2,6.2,0,0,1-.12,2A6.81,6.81,0,0,1,124.88,233.72Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M124,244.05a3.33,3.33,0,0,1,.4-2.34c.55-1.22,1.42-1.92,1.51-1.82s-.53.91-1,2S124.13,244.06,124,244.05Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M122,249.74a11.08,11.08,0,0,1-2.21-1.25c-1.2-.72-2.22-1.22-2.16-1.36a4.81,4.81,0,0,1,2.42.91C121.31,248.77,122.12,249.64,122,249.74Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.43,248.57a11.88,11.88,0,0,1-.83,2.53,11.55,11.55,0,0,1-.93,2.49,5,5,0,0,1,.44-2.66A5.14,5.14,0,0,1,130.43,248.57Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M122,256.09a4.35,4.35,0,0,1-2.07-.33c-1.11-.32-2-.69-1.93-.83a4.35,4.35,0,0,1,2.07.33C121.2,255.58,122.06,256,122,256.09Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.28,220.18a6.56,6.56,0,0,1-2.23,1.31,6.68,6.68,0,0,1-2.44.84,12.76,12.76,0,0,1,4.67-2.15Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M123.08,213.2c.11.11-.71,1-1.61,2.2a12.49,12.49,0,0,1-1.68,2.14,5.22,5.22,0,0,1,1.27-2.46C122,213.85,123,213.09,123.08,213.2Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M139.09,229.06a5.86,5.86,0,0,1-2.42-1.56,5.69,5.69,0,0,1-1.77-2.27,14.44,14.44,0,0,1,2.12,1.88C138.16,228.16,139.17,228.93,139.09,229.06Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.64,219.51A12.37,12.37,0,0,1,147,222a11.78,11.78,0,0,1-1.76,2.33,6.57,6.57,0,0,1,1.34-2.63C147.55,220.31,148.54,219.41,148.64,219.51Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M142.57,237.46a11.72,11.72,0,0,1-4.91,0,11.72,11.72,0,0,1,4.91,0Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M151.6,234a5.08,5.08,0,0,1-.72-2.68,5,5,0,0,1,.32-2.75,14.06,14.06,0,0,1,.2,2.71A13.56,13.56,0,0,1,151.6,234Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.94,245.72a7.85,7.85,0,0,1-2.57-1.08,7.71,7.71,0,0,1-2.32-1.53,7.6,7.6,0,0,1,2.57,1.07A7.42,7.42,0,0,1,153.94,245.72Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M160.38,239.77c.07.13-.51.57-1.29,1s-1.48.67-1.55.54.51-.57,1.3-1S160.32,239.64,160.38,239.77Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M140.1,250.76a6.18,6.18,0,0,1,.68-3,5.89,5.89,0,0,1,1.67-2.56,19.19,19.19,0,0,1-1.19,2.76A17.55,17.55,0,0,1,140.1,250.76Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M150.7,255.8a7.41,7.41,0,0,1-1.64-3.1,7.33,7.33,0,0,1-.53-3.47,31.58,31.58,0,0,1,1,3.31A32.18,32.18,0,0,1,150.7,255.8Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M158.08,252.2c.12.09-.26.72-.56,1.54s-.43,1.54-.58,1.54-.25-.8.09-1.72S158,252.1,158.08,252.2Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M169.06,243.43a11.87,11.87,0,0,1-4.66,1.67,6.15,6.15,0,0,1,2.24-1.08A6.26,6.26,0,0,1,169.06,243.43Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M168.55,237a4.67,4.67,0,0,1,.24-2.62A4.62,4.62,0,0,1,170,232a13.29,13.29,0,0,1-.74,2.47A12.66,12.66,0,0,1,168.55,237Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M165.44,231.52a6.88,6.88,0,0,1-5.3-.67,16.15,16.15,0,0,1,2.65.35A15.18,15.18,0,0,1,165.44,231.52Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M161.82,225.07a4.19,4.19,0,0,1,1.31-2.1c.94-1,1.94-1.55,2-1.43s-.73.82-1.63,1.79S162,225.15,161.82,225.07Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.06,220.29a11,11,0,0,1-1.07-4.64,11,11,0,0,1,1.07,4.64Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M122,270.52c.08.11-.28.55-.81,1s-1,.68-1.13.57.27-.55.8-1S121.94,270.41,122,270.52Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M160.39,276.5a8.9,8.9,0,0,1-3,.13,9,9,0,0,1-3-.4,18.2,18.2,0,0,1,6.07.27Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M136.21,252.3c.07.13-4,2.67-9.16,5.68s-9.35,5.34-9.42,5.22,4-2.66,9.16-5.67S136.13,252.18,136.21,252.3Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.67,276.28c-.48,0-5.78,15.64-.71,26,.51,1,2.28,3.38,4.49,6.77,10.5,16.11,37.12,52.19,37.92,57.74,1,6.72,18.15,77,18.15,77h14l-11.77-80.19-17.54-76.07Z",
					style: { fill: "#ffbe9d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M161.78,382.41a9.09,9.09,0,0,0,2.93-7.2c-.12-4.82-2.94-16.32-2.94-16.32l-4.51,2.76s3.55,9.44,3.72,12.4c.2,3.31-.42,4.39-.42,4.39Z",
					style: { fill: "#eb996e" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M125.25,315.33l14.81,55L93.79,418.44,103.52,430s56.84-46.6,57.87-53.3c1.18-7.65-12.68-62-12.68-62Z",
					style: { fill: "#ffbe9d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M106.25,428.58h0L95.86,416.29l-2.74,2.59,3.51,4.77c2.42,3.18,10.75,13.73,13.1,15.24C112.35,440.57,106.25,428.58,106.25,428.58Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M110.49,438.69c.1-.09-3.67-4.63-8.42-10.15s-8.7-9.91-8.8-9.82,3.67,4.63,8.42,10.15S110.39,438.78,110.49,438.69Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M95.89,421.92c.06,0,.19-.25.34-.7a5.29,5.29,0,0,0,.23-1.88,2.91,2.91,0,0,0-.75-1.78c-.36-.36-.68-.44-.7-.39s.19.25.43.61a3.54,3.54,0,0,1,.53,1.6,9.47,9.47,0,0,1-.09,1.77C95.83,421.61,95.82,421.91,95.89,421.92Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M106.7,429.54c0,.15-.53.16-1.13.15s-1.09-.05-1.11-.19.47-.35,1.12-.34S106.73,429.4,106.7,429.54Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M107.29,430.69c0,.15-.5.25-1.08.24s-1-.15-1.06-.3.47-.25,1.08-.23S107.3,430.55,107.29,430.69Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M107.75,431.71c0,.15-.37.27-.82.34s-.84.06-.88-.08.31-.36.8-.43S107.75,431.57,107.75,431.71Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M106.59,429.64a3.56,3.56,0,0,1,.73-1.5,5,5,0,0,1,1.3-1.32,3.9,3.9,0,0,1,1-.5,2.36,2.36,0,0,1,.63-.11,1,1,0,0,1,.71.29,1,1,0,0,1-.24,1.37,5.73,5.73,0,0,1-.93.59,10.06,10.06,0,0,1-1.68.71,3.92,3.92,0,0,1-1.63.32,7.88,7.88,0,0,1,1.5-.67,14.2,14.2,0,0,0,1.57-.78,8,8,0,0,0,.83-.56c.24-.19.31-.5.19-.63s-.47-.14-.8,0a3.8,3.8,0,0,0-.89.41,5.68,5.68,0,0,0-1.26,1.15C107,429.14,106.66,429.68,106.59,429.64Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M106.7,429.35a3.78,3.78,0,0,1,1.64-.39,7,7,0,0,1,1.86.06,4.66,4.66,0,0,1,1.08.31,1.87,1.87,0,0,1,.55.3.74.74,0,0,1,.26.31.55.55,0,0,1,0,.5,1.54,1.54,0,0,1-1.17.68,3.15,3.15,0,0,1-1.15,0,7.2,7.2,0,0,1-1.76-.61c-1-.46-1.36-1.05-1.3-1.09a13.27,13.27,0,0,0,1.45.75,10.13,10.13,0,0,0,1.69.48,3.57,3.57,0,0,0,1,0,1.23,1.23,0,0,0,.78-.39c.1,0-.22-.32-.54-.43a5.2,5.2,0,0,0-1-.31,8.12,8.12,0,0,0-1.75-.16A9.4,9.4,0,0,1,106.7,429.35Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M106.05,428.33c-.14.11-2.68-2.4-5.47-5.74s-4.85-6.2-4.71-6.3,2.43,2.59,5.22,5.92S106.19,428.22,106.05,428.33Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M191.06,443.8h0l-14.74-.16.17,4.63,1,0c4.28.07,21.76.06,24.58-.85C205.18,446.42,191.06,443.8,191.06,443.8Z",
					style: { fill: "#8A6BD6" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M202.37,446.72c0-.14-5.8,0-12.94.29s-12.91.66-12.91.79,5.8,0,12.94-.29S202.37,446.85,202.37,446.72Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M181.18,447.56c.06-.05-.08-.31-.37-.71a5.15,5.15,0,0,0-1.42-1.34,3.3,3.3,0,0,0-2-.51c-.54.05-.82.26-.79.31s.33,0,.8,0a3.87,3.87,0,0,1,1.7.57,8.77,8.77,0,0,1,1.42,1.16C180.88,447.41,181.12,447.6,181.18,447.56Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192.16,444c.1.12-.22.51-.62,1s-.76.83-.9.76,0-.59.47-1.1S192.07,443.93,192.16,444Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M193.52,444.29c.11.1-.12.54-.51,1s-.82.73-.95.65.1-.52.52-1S193.41,444.19,193.52,444.29Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M194.68,444.56c.13.08,0,.45-.25.85s-.51.7-.65.64-.1-.47.16-.9S194.56,444.47,194.68,444.56Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192.17,444.19a3.74,3.74,0,0,1-.77-1.5,5.08,5.08,0,0,1-.26-1.84,3.79,3.79,0,0,1,.25-1.1,2.16,2.16,0,0,1,.32-.56,1,1,0,0,1,.72-.38,1,1,0,0,1,1,1,6,6,0,0,1-.12,1.1,10.1,10.1,0,0,1-.51,1.76,3.92,3.92,0,0,1-.81,1.48,6.44,6.44,0,0,1,.43-1.6,13.42,13.42,0,0,0,.38-1.71,6.85,6.85,0,0,0,.08-1c0-.3-.22-.55-.41-.53s-.42.27-.55.6a3.34,3.34,0,0,0-.25.95,5.09,5.09,0,0,0,.13,1.7A7.66,7.66,0,0,1,192.17,444.19Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M192,443.93a3.71,3.71,0,0,1,.76-1.54A7.34,7.34,0,0,1,194,441a5.85,5.85,0,0,1,1-.65,2.59,2.59,0,0,1,.63-.25.87.87,0,0,1,.43,0,.62.62,0,0,1,.43.3,1.49,1.49,0,0,1-.2,1.35,3.73,3.73,0,0,1-.79.88,8.59,8.59,0,0,1-1.68,1,2.63,2.63,0,0,1-1.78.35,11.72,11.72,0,0,0,1.6-.68,9.23,9.23,0,0,0,1.51-1,3.2,3.2,0,0,0,.65-.77,1.12,1.12,0,0,0,.19-.85c0-.1-.42,0-.72.16a5.1,5.1,0,0,0-.9.57,8.76,8.76,0,0,0-1.3,1.27A9.92,9.92,0,0,1,192,443.93Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M190.71,443.8a37.12,37.12,0,0,1-7.08.37,40.75,40.75,0,0,1-7.08-.4,56.52,56.52,0,0,1,7.08-.12A68.37,68.37,0,0,1,190.71,443.8Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147,210.48c-.07-3.15-.11-6-.11-6s6.17-.65,6.54-6.76,0-20.22,0-20.22l-11.23-5.49-12.35,9.36.72,29.45a8.22,8.22,0,0,0,8.21,8h0A8.22,8.22,0,0,0,147,210.48Z",
					style: { fill: "#ffbe9d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.67,186.12s10.09-1,11.87-10.1l11,10.1a11.8,11.8,0,0,0-2.74-13.07c-6.07-6.3-10.23-5-12.61-5-2.21,0-13.42,2.38-16.76,15.13-.24.93-.44,3.22-.59,4.26Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M152.09,187.82a.78.78,0,1,1-.78-.78A.78.78,0,0,1,152.09,187.82Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M152.85,187c-.1.1-.68-.39-1.52-.44s-1.48.36-1.56.25.06-.24.33-.43a2.1,2.1,0,0,1,1.26-.33,2.08,2.08,0,0,1,1.21.48C152.82,186.72,152.9,186.92,152.85,187Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M143,187.82a.78.78,0,1,1-.78-.78A.78.78,0,0,1,143,187.82Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M143.51,187c-.1.1-.68-.39-1.52-.44s-1.48.36-1.57.25.07-.24.34-.43a2.09,2.09,0,0,1,2.47.15C143.48,186.72,143.56,186.92,143.51,187Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146.55,194.08a6,6,0,0,1,1.38-.17c.21,0,.42,0,.47-.2a1.23,1.23,0,0,0-.12-.68l-.58-1.75c-.4-1.24-.74-2.37-1-3.19a6.19,6.19,0,0,1-.31-1.36A5.48,5.48,0,0,1,147,188c.29.81.67,1.93,1.07,3.17.2.61.38,1.2.56,1.75a1.37,1.37,0,0,1,.08.88.5.5,0,0,1-.36.31,1.63,1.63,0,0,1-.36,0A5.48,5.48,0,0,1,146.55,194.08Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M143.77,194.88a33.31,33.31,0,0,0,4.07,1.4,2.33,2.33,0,0,1-2.79.8C143.25,196.32,143.77,194.88,143.77,194.88Z",
					style: { fill: "#fafafa" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146.88,204.52a15.24,15.24,0,0,1-8.1-2.73s2,4.5,8.1,4.25Z",
					style: { fill: "#eb996e" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M142.24,175.29s2.24,4.33,1.28,7.59l9.81,2.53S155.56,173,142.24,175.29Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M120.79,187.44s-1.73,13.13,10.17,15.67l-.29-17Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M143.11,171.29a7,7,0,0,1,3,.36A13.54,13.54,0,0,1,155.75,182a7,7,0,0,1,.14,3c-.12,0-.13-1.16-.61-2.93a14.32,14.32,0,0,0-9.3-10C144.25,171.5,143.1,171.4,143.11,171.29Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146,187.44s0-.43-.22-1.16a4.78,4.78,0,0,0-1.75-2.56,4.63,4.63,0,1,0,0,7.43,4.78,4.78,0,0,0,1.75-2.56c.2-.73.18-1.16.22-1.15a1.36,1.36,0,0,1,0,.3,3.65,3.65,0,0,1-.1.88,4.83,4.83,0,0,1-3.8,3.66,4.95,4.95,0,0,1-4.9-1.91,4.93,4.93,0,0,1,0-5.87,4.95,4.95,0,0,1,4.9-1.91,4.88,4.88,0,0,1,2.07.94,4.78,4.78,0,0,1,1.73,2.72,3.7,3.7,0,0,1,.1.88A1.5,1.5,0,0,1,146,187.44Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M157.07,187.44s0-.43-.21-1.16a4.78,4.78,0,0,0-1.75-2.56,4.67,4.67,0,0,0-6.56,1,4.64,4.64,0,0,0,4.59,7.3,4.65,4.65,0,0,0,2-.85,4.78,4.78,0,0,0,1.75-2.56c.19-.73.17-1.16.21-1.15a1,1,0,0,1,0,.3,3.65,3.65,0,0,1-.1.88,4.9,4.9,0,0,1-8.7,1.75,4.93,4.93,0,0,1,0-5.87,4.77,4.77,0,0,1,2.31-1.71,4.83,4.83,0,0,1,2.59-.2,4.89,4.89,0,0,1,2.06.94,4.8,4.8,0,0,1,1.74,2.72,3.7,3.7,0,0,1,.1.88A1.09,1.09,0,0,1,157.07,187.44Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147.49,187.59c0,.09-.4.17-.88.17s-.88-.08-.88-.17.4-.17.88-.17S147.49,187.49,147.49,187.59Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M136.61,188.44a27.92,27.92,0,0,1-4.22,1,26.91,26.91,0,0,1-4.27.67,27.59,27.59,0,0,1,4.21-1A28.2,28.2,0,0,1,136.61,188.44Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130,195.64a2.55,2.55,0,0,1-3.19-.43,3.75,3.75,0,0,1-.82-3.29,2.81,2.81,0,0,1,1-1.8,2.9,2.9,0,0,1,2.74.17Z",
					style: { fill: "#ffbe9d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M128.63,194.65c0-.08-.31-.13-.67-.39a1.62,1.62,0,0,1-.67-1.45,1.57,1.57,0,0,1,.93-1.3c.4-.2.72-.19.72-.27s-.31-.22-.85-.08a1.85,1.85,0,0,0-.32,3.42C128.28,194.81,128.63,194.72,128.63,194.65Z",
					style: { fill: "#eb996e" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M117.82,273.19s-10.73,11.14-8.52,35S114.41,364,114.41,364s13.8-12.45,20.81-7.13,14,9.67,23.15,3.9c12.48-7.9,26.16-2.68,26.16-2.68l-22-78.89Z",
					style: { fill: "#263238" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.76,276a5.37,5.37,0,0,1-.45,2.36,10.05,10.05,0,0,1-3.47,4.63,9.94,9.94,0,0,1-5.46,1.88,5.26,5.26,0,0,1-2.38-.3c0-.09.91.08,2.35-.06a10.33,10.33,0,0,0,8.62-6.29C131.54,276.92,131.67,276,131.76,276Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M122.18,276.33c-.14-.05-.07-.61.16-1.27s.51-1.14.65-1.1.06.62-.16,1.27S122.31,276.37,122.18,276.33Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M119.81,285.74a5.8,5.8,0,0,1,.26-2.43,5.86,5.86,0,0,1,.77-2.31,5.94,5.94,0,0,1-.26,2.42A5.84,5.84,0,0,1,119.81,285.74Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M118.58,295.37a11.41,11.41,0,0,1,.48-4.83,6,6,0,0,1,0,2.44A5.75,5.75,0,0,1,118.58,295.37Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M118.34,305.08a5.85,5.85,0,0,1-.25-2.43,5.75,5.75,0,0,1,.26-2.43,6,6,0,0,1,.26,2.43A5.69,5.69,0,0,1,118.34,305.08Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M118.94,314.78a6,6,0,0,1-.45-2.4,5.72,5.72,0,0,1,.06-2.44,5.82,5.82,0,0,1,.45,2.39A6,6,0,0,1,118.94,314.78Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M120.17,324.42a5.79,5.79,0,0,1-.6-2.38,5.86,5.86,0,0,1-.08-2.44,6,6,0,0,1,.6,2.37A6.13,6.13,0,0,1,120.17,324.42Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M121.94,334a5.73,5.73,0,0,1-.74-2.33,6,6,0,0,1-.22-2.43,11.69,11.69,0,0,1,1,4.76Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M124.14,343.42a5.89,5.89,0,0,1-.82-2.3,5.82,5.82,0,0,1-.32-2.42,5.89,5.89,0,0,1,.82,2.3A5.8,5.8,0,0,1,124.14,343.42Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M125.94,350.55c-.14,0-.39-.48-.56-1.15s-.2-1.24-.06-1.27.39.48.56,1.15S126.08,350.52,125.94,350.55Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M150.81,298a18.72,18.72,0,0,1-.4-3c-.19-1.86-.44-4.42-.64-7.26s-.3-5.41-.3-7.28a16.38,16.38,0,0,1,.14-3,18.2,18.2,0,0,1,.23,3c.09,1.86.24,4.42.45,7.26s.39,5.4.48,7.26A16.49,16.49,0,0,1,150.81,298Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M152.47,277.93a18.84,18.84,0,0,1,.35,3.1c.16,1.91.33,4.55.49,7.48.07,1.45.14,2.84.2,4.12a8,8,0,0,1-.37,3.41,3.38,3.38,0,0,1-1.51,1.77c-.5.25-.82.24-.82.21s.29-.1.72-.38a3.51,3.51,0,0,0,1.27-1.73,8.34,8.34,0,0,0,.23-3.25c-.07-1.29-.16-2.67-.24-4.12-.16-2.93-.28-5.58-.33-7.49A18.85,18.85,0,0,1,152.47,277.93Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M164.88,287.6a3.55,3.55,0,0,1-1.72-.42,8.89,8.89,0,0,1-3.4-2.59,9,9,0,0,1-1.81-3.88,3.8,3.8,0,0,1,0-1.77,14.47,14.47,0,0,1,.41,1.69,10,10,0,0,0,5,6.22A17.12,17.12,0,0,1,164.88,287.6Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.17,352.79a4.65,4.65,0,0,1-.75-.09l-2.15-.33a65.32,65.32,0,0,0-8-.69,38.27,38.27,0,0,0-11.66,1.48c-2.13.61-4.23,1.63-6.51,2.53a17.68,17.68,0,0,1-3.61,1,9.16,9.16,0,0,1-3.89-.2c-2.57-.71-4.64-2.27-6.74-3.43a21.62,21.62,0,0,0-6.49-2.31,24,24,0,0,0-6.26-.32,26.58,26.58,0,0,0-5.36,1.09,23.43,23.43,0,0,0-7,3.69,16.75,16.75,0,0,0-1.65,1.4,5,5,0,0,1-.58.5,3.6,3.6,0,0,1,.51-.57,13.71,13.71,0,0,1,1.59-1.49,22.59,22.59,0,0,1,7-3.88,26.35,26.35,0,0,1,5.43-1.17,24.79,24.79,0,0,1,6.38.27,21.87,21.87,0,0,1,6.66,2.35c2.14,1.17,4.19,2.7,6.63,3.37s5,.05,7.18-.81,4.38-1.9,6.56-2.51a37.72,37.72,0,0,1,11.8-1.39,57.92,57.92,0,0,1,8,.86c.93.17,1.65.31,2.14.43A3.14,3.14,0,0,1,184.17,352.79Z",
					style: { fill: "#455a64" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M189.67,263.19c2.39-.52,6.94-2.39,7-3,.19-1.14-4,.2-5.17.43s-7.41-.9-7.41-.9h0c-1.53-.85-3-1.74-4.22-2.46a4.06,4.06,0,0,1-1-4.22c.6-1.77.64-3.25.33-3.81a1.07,1.07,0,0,0-1.94.54,12.38,12.38,0,0,1-1.25,3.2,8.46,8.46,0,0,1-1.69,2.25c-.76.71-1.44,1.29-2,1.77-5.3.95-20.34,3.1-33.54-.27a10.4,10.4,0,0,1-4.15-3.34l-14.85,8.94c6.89,21.86,57,7.74,57,7.74l13.73-4.65s7.64-1.87,7.64-2.52C198.19,261.86,192.54,263.15,189.67,263.19Z",
					style: { fill: "#ffbe9d" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M146.9,210.93a3,3,0,0,1,0,1,9.21,9.21,0,0,1-.84,2.75,8.8,8.8,0,0,1-2.7,3.29,7.56,7.56,0,0,1-5,1.46,7.71,7.71,0,0,1-4.79-2,9.06,9.06,0,0,1-2.35-3.56,9.36,9.36,0,0,1-.57-2.81,3.2,3.2,0,0,1,.07-1,15,15,0,0,0,.85,3.72,9.09,9.09,0,0,0,2.32,3.34,7.4,7.4,0,0,0,4.51,1.88,7.31,7.31,0,0,0,4.69-1.32,8.93,8.93,0,0,0,2.65-3.08A13.82,13.82,0,0,0,146.9,210.93Z",
					style: { fill: "#263238" }
				})
			]
		})
	]
});
export default SvgNoDocuments;
